import { createSlice } from "@reduxjs/toolkit";
import { createTemplate, fetchTemplates, updateTemplate, deleteTemplate, fetchTemplateAndSignatureStats } from "./certificateAndLetterManagement.action";

const initialState = {
  certificatesDataCounts: {},
  templateData: [],
  loading: false,
  error: null,
};

const certificatesSlice = createSlice({
  name: "certificatesManagement",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchTemplateAndSignatureStats.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTemplateAndSignatureStats.fulfilled, (state, action) => {
        state.loading = false;
        state.certificatesDataCounts = action.payload;
        state.error = null;
      })
      .addCase(fetchTemplateAndSignatureStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || true;
      })


      .addCase(createTemplate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createTemplate.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(createTemplate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || true;
      })

      .addCase(fetchTemplates.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTemplates.fulfilled, (state, action) => {
        state.loading = false;
        state.templateData = action?.payload?.data;
        state.error = null;
      })
      .addCase(fetchTemplates.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || true;
      })

      .addCase(updateTemplate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateTemplate.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(updateTemplate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || true;
      })

      .addCase(deleteTemplate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteTemplate.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(deleteTemplate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || true;
      })
  },
});

export default certificatesSlice.reducer;
